export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Debug"] = 0] = "Debug";
    LogLevel[LogLevel["Log"] = 1] = "Log";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
})(LogLevel || (LogLevel = {}));
/**
 * ログを管理するユーティリティです
 */
export class Logger {
    static logLevel = LogLevel.Debug;
    static get debug() {
        return this.logLevel <= LogLevel.Debug ? console.debug : this.emptyEvent;
    }
    ;
    static get log() {
        return this.logLevel <= LogLevel.Log ? console.log : this.emptyEvent;
    }
    ;
    static get info() {
        return this.logLevel <= LogLevel.Info ? console.info : this.emptyEvent;
    }
    ;
    static get warn() {
        return this.logLevel <= LogLevel.Warn ? console.warn : this.emptyEvent;
    }
    ;
    static get error() {
        return this.logLevel <= LogLevel.Error ? console.error : this.emptyEvent;
    }
    ;
    static setLogLevel(logLevel) {
        this.logLevel = logLevel;
    }
    static emptyEvent = (...data) => {
        void data;
    };
}
//# sourceMappingURL=Logger.js.map